"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UriEvaluationHandler = void 0;
const jsonpath_1 = __importDefault(require("jsonpath"));
const nanoid_1 = require("nanoid");
const ConstraintUtils_1 = require("../../ConstraintUtils");
const types_1 = require("../../types");
const Messages_1 = __importDefault(require("../../types/Messages"));
const abstractEvaluationHandler_1 = require("./abstractEvaluationHandler");
class UriEvaluationHandler extends abstractEvaluationHandler_1.AbstractEvaluationHandler {
    constructor(client) {
        super(client);
    }
    getName() {
        return 'UriEvaluation';
    }
    //TODO: handle context objects
    //TODO: handle hashlinks
    handle(d, wrappedVcs) {
        // This filter is removed in V2
        d.input_descriptors.forEach((inDesc, i) => {
            const uris = d.getVersion() !== types_1.PEVersion.v2 ? inDesc.schema.map((so) => so.uri) : [];
            wrappedVcs.forEach((wvc, j) => {
                const vcUris = UriEvaluationHandler.buildVcContextAndSchemaUris(wvc.internalCredential);
                this.evaluateUris(wvc, vcUris, uris, i, j, d.getVersion());
            });
        });
        const descriptorMap = this.getResults()
            .filter((e) => e.status === ConstraintUtils_1.Status.INFO)
            .map((e) => {
            const inputDescriptor = jsonpath_1.default.nodes(d, e.input_descriptor_path)[0].value;
            return {
                id: inputDescriptor.id,
                format: 'ldp_vc',
                path: e.verifiable_credential_path,
            };
        });
        this.presentationSubmission = {
            id: (0, nanoid_1.nanoid)(),
            definition_id: d.id,
            descriptor_map: descriptorMap,
        };
    }
    evaluateUris(wvc, verifiableCredentialUris, inputDescriptorsUris, idIdx, vcIdx, pdVersion) {
        let hasAnyMatch = false;
        if (pdVersion === types_1.PEVersion.v1) {
            for (let i = 0; i < inputDescriptorsUris.length; i++) {
                if (UriEvaluationHandler.containsHashlink(inputDescriptorsUris[i])) {
                    this.getResults().push(this.createWarnResultObject(idIdx, vcIdx));
                }
            }
            for (let i = 0; i < verifiableCredentialUris.length; i++) {
                if (inputDescriptorsUris.find((el) => el === verifiableCredentialUris[i]) != undefined) {
                    hasAnyMatch = true;
                }
            }
        }
        else {
            hasAnyMatch = true;
        }
        if (hasAnyMatch) {
            this.getResults().push(this.createSuccessResultObject(wvc, inputDescriptorsUris, idIdx, vcIdx));
        }
        else {
            this.getResults().push(this.createErrorResultObject(wvc, inputDescriptorsUris, idIdx, vcIdx));
        }
    }
    static buildVcContextAndSchemaUris(credential) {
        const uris = [];
        if (Array.isArray(credential['@context'])) {
            credential['@context'].forEach((value) => uris.push(value));
        }
        else {
            uris.push(credential['@context']);
        }
        if (Array.isArray(credential.credentialSchema) && credential.credentialSchema.length > 0) {
            credential.credentialSchema.forEach((element) => uris.push(element.id));
        }
        else if (credential.credentialSchema) {
            uris.push(credential.credentialSchema.id);
        }
        return uris;
    }
    createSuccessResultObject(wvc, inputDescriptorsUris, idIdx, vcIdx) {
        const result = this.createResult(idIdx, vcIdx);
        result.status = ConstraintUtils_1.Status.INFO;
        result.message = Messages_1.default.URI_EVALUATION_PASSED;
        result.payload = {
            vcContext: wvc.internalCredential['@context'],
            vcCredentialSchema: wvc.internalCredential.credentialSchema,
            inputDescriptorsUris,
        };
        return result;
    }
    createErrorResultObject(wvc, inputDescriptorsUris, idIdx, vcIdx) {
        const result = this.createResult(idIdx, vcIdx);
        result.status = ConstraintUtils_1.Status.ERROR;
        result.message = Messages_1.default.URI_EVALUATION_DIDNT_PASS;
        result.payload = {
            vcContext: wvc.internalCredential['@context'],
            vcCredentialSchema: wvc.internalCredential.credentialSchema,
            inputDescriptorsUris,
        };
        return result;
    }
    createWarnResultObject(idIdx, vcIdx) {
        const result = this.createResult(idIdx, vcIdx);
        result.status = ConstraintUtils_1.Status.WARN;
        result.message = Messages_1.default.URI_EVALUATION_DIDNT_PASS;
        result.payload = Messages_1.default.INPUT_DESCRIPTOR_CONTEXT_CONTAINS_HASHLINK_VERIFICATION_NOT_SUPPORTED;
        return result;
    }
    createResult(idIdx, vcIdx) {
        return {
            input_descriptor_path: `$.input_descriptors[${idIdx}]`,
            verifiable_credential_path: `$[${vcIdx}]`,
            evaluator: this.getName(),
            status: ConstraintUtils_1.Status.INFO,
            message: undefined,
        };
    }
    static containsHashlink(url) {
        return !(this.matchAll(url, UriEvaluationHandler.HASHLINK_QUERY_URL_REGEX).next().done &&
            this.matchAll(url, UriEvaluationHandler.HASHLINK_URL_ENCODED_REGEX).next().done);
    }
}
exports.UriEvaluationHandler = UriEvaluationHandler;
UriEvaluationHandler.matchAll = require('string.prototype.matchall');
UriEvaluationHandler.HASHLINK_URL_ENCODED_REGEX = /hl:[a-zA-Z0-9]+:[a-zA-Z0-9]+/g;
UriEvaluationHandler.HASHLINK_QUERY_URL_REGEX = /https*?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&/=]*)(hl=[a-zA-Z0-9]+)/g;
